/**
 * fo_mhead is both the FO posting-head master and the GST slab table: each row carries a
 * band (hd_mintariff..hd_maxtariff) for one charge category (hd_type: 1 Tariff, 2 Plan,
 * 3 Extra Adult, 4 Extra Child) plus that band's CGST/SGST/Tax3 percentages. So the head a
 * posting lands on IS its tax rate, and picking the head is picking the band.
 *
 * Shared by CheckInForm and CheckOutForm so a stay cannot change band merely by being billed
 * from a different screen. Mirrors the web's ui/.../FOCheckin/utils.ts findHeadByTariff,
 * including its two quirks, which are behaviour rather than accident:
 *   - returns the FIRST array match, and the heads endpoint orders by hd_id, so overlapping
 *     bands resolve to the lowest hd_id;
 *   - requires hd_flag === '1', so a deactivated head is never selected.
 *
 * Returns null when no active band covers the amount - callers must treat that as "leave the
 * row's existing head alone" rather than as 0% tax.
 */
export const findHeadByTariff = (
  tariff: number,
  headType: number,
  headData: any[] | undefined
): any | null => {
  if (!headData || headData.length === 0) return null;

  const matchedHead = headData.find(
    (head: any) =>
      Number(head.hd_type) === Number(headType) &&
      Number(tariff) >= Number(head.hd_mintariff || 0) &&
      Number(tariff) <= Number(head.hd_maxtariff || 999999999) &&
      head.hd_flag === '1'
  );

  return matchedHead || null;
};
